/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Inherited_Prefix_TeamInputs */

const en_settings_inherited_prefix_team = /** @type {(inputs: Settings_Inherited_Prefix_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This setting is set for the `)
};

const de_settings_inherited_prefix_team = /** @type {(inputs: Settings_Inherited_Prefix_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einstellung ist für das `)
};

/**
* | output |
* | --- |
* | "This setting is set for the" |
*
* @param {Settings_Inherited_Prefix_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_inherited_prefix_team = /** @type {((inputs?: Settings_Inherited_Prefix_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Inherited_Prefix_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_inherited_prefix_team(inputs)
	return de_settings_inherited_prefix_team(inputs)
});